module.exports = __webpack_public_path__ + "media/Loops Pad.a8eed61c.wav";